import { type ReactNode, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth-context";

const NAV_ITEMS = [
  { to: "/", label: "Bench", end: true },
  { to: "/recipes", label: "Recipes" },
  { to: "/batches", label: "Batch log" },
  { to: "/pantry", label: "Pantry" },
];

export function AppShell({ children }: { children: ReactNode }) {
  const { account, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  function onSearch(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const q = new FormData(e.currentTarget).get("q");
    if (q) navigate(`/recipes?q=${encodeURIComponent(String(q))}`);
  }

  return (
    <div className="app-shell">
      <nav className="app-nav">
        <span className="nav-brand">ALEMBIC</span>
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `app-nav-link${isActive ? " active" : ""}`}
          >
            {item.label}
          </NavLink>
        ))}
        <span className="app-nav-spacer" />
        <form onSubmit={onSearch} className="flex-row" style={{ gap: 12 }}>
          <input name="q" className="input" placeholder="Search botanicals, bases, people" style={{ width: 250, minHeight: 34 }} />
          <button type="button" className="btn btn-primary" onClick={() => navigate("/recipes")}>
            Start a batch
          </button>
          <div style={{ position: "relative" }}>
            <button type="button" className="avatar-badge" onClick={() => setMenuOpen((v) => !v)}>
              {account?.avatar_initials ?? "??"}
            </button>
            {menuOpen && (
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: 40,
                  background: "var(--color-bg)",
                  border: "2px solid var(--color-text)",
                  minWidth: 180,
                  zIndex: 30,
                }}
              >
                <button
                  className="btn btn-block"
                  style={{ padding: "10px 14px" }}
                  onClick={() => {
                    setMenuOpen(false);
                    navigate("/settings");
                  }}
                >
                  Settings
                </button>
                <button
                  className="btn btn-block"
                  style={{ padding: "10px 14px", borderTop: "1px solid var(--color-divider)" }}
                  onClick={async () => {
                    setMenuOpen(false);
                    await logout();
                    navigate("/sign-in");
                  }}
                >
                  Sign out
                </button>
              </div>
            )}
          </div>
        </form>
      </nav>

      <div className="disclaimer-bar">
        <span className="disclaimer-dot" />
        <p className="muted" style={{ margin: 0, fontSize: 12, lineHeight: 1.5 }}>
          Alembic is for infusions, macerations and compounded liqueurs made on spirit you bought. We don't publish
          still work — check what's legal where you live.
        </p>
      </div>

      {children}
    </div>
  );
}
